import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <BlogHero />
        <BlogGrid />
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
